// extracted by mini-css-extract-plugin
export default {"darkModeContrainer":"DarkMode_darkModeContrainer__kyX1C","darkModeForm":"DarkMode_darkModeForm__0-MXm","dark":"DarkMode_dark__-8kgN"};